import useFileSaver from '@hooks/useFileSaver';
import useRequest, { IEnumRecord } from '@hooks/useRequest';
import { IVendedorMovimentacao, VendedorMovimentacaoTipoEnum } from '@model/VendedorMovimentacao';
import { IVendedorMovimentacaoLinha } from '@model/VendedorMovimentacaoLinha';
import { TDate } from '@utils/TypeHelpers';
import React from 'react';

export interface IVendedorMovimentacaoFilter {
    ano: TDate
}

export interface IResgatarRequest {
    linhaIds: number[]
}

export interface IAtribuirRequest {
    linhaIds: number[]
}

interface IProtocoloMovimentacaoItem {
    numeroLinha: string
    nomeEmpresa: string
    numeroContrato: string
}

export interface IProtocoloMovimentacao {
    id: number
    nomeTipo: string
    atendente: string
    vendedor: string
    telefoneVendedor: string
    itens: IProtocoloMovimentacaoItem[]
    dia: string
    mesExtenso: string
    ano: string
}

const controller = '/VendedorMovimentacao';

export function useVendedorMovimentacaoService () {
    const _request = useRequest();
    const fileSaver = useFileSaver();

    const listar = React.useCallback((vendedorId: number, request: IVendedorMovimentacaoFilter) => {
        return _request.get<IVendedorMovimentacao[]>(`${controller}/Listar/${vendedorId}`, {
            params: request
        });
    }, [_request]);

    const listarTipos = React.useCallback(() => {
        return _request.get<IEnumRecord<VendedorMovimentacaoTipoEnum>[]>(`${controller}/listarTipos`);
    }, [_request]);

    const resgatar = React.useCallback((vendedorId: number, request: IResgatarRequest) => {
        return _request.post(`${controller}/Resgatar/${vendedorId}`, request);
    }, [_request])

    const baixarRecibo = React.useCallback((vendedorMovimentacaoId: number) => {
        return _request.download(`${controller}/BaixarRecibo/${vendedorMovimentacaoId}`)
            .then(response => { 
                fileSaver.save(response, `movimentacao-${vendedorMovimentacaoId}.pdf`);
            });
    }, [_request, fileSaver]);

    const atribuir = React.useCallback((vendedorId: number, request: IAtribuirRequest) => {
        return _request.post(`${controller}/Atribuir/${vendedorId}`, request);
    }, [_request])

    const obterProtocolo = React.useCallback((vendedorMovimentacaoId: number) => {
        return _request.get<IProtocoloMovimentacao>(`${controller}/ObterProtocolo/${vendedorMovimentacaoId}`);
    }, [_request]);

    const listarLinhas = React.useCallback((vendedorMovimentacaoId: number) => {
        return _request.get<IVendedorMovimentacaoLinha[]>(`${controller}/listarLinhas/${vendedorMovimentacaoId}`);
    }, [_request]);

    return React.useMemo(() => ({
        listarTipos, listar, resgatar, atribuir, baixarRecibo, obterProtocolo, listarLinhas
    }), [listarTipos, listar, resgatar, atribuir, baixarRecibo, obterProtocolo, listarLinhas]);
}